// extracted by mini-css-extract-plugin
export default {"header":"_header_cpOcM9","title":"_title_y0fNYx","form-body":"_form-body_+Fn2Bv","body":"_body_I2vdyJ","right-hand":"_right-hand_7c+fqM","left-hand":"_left-hand_HODY+E"};